import { Grid, Box, Card, Typography } from '@mui/material';
import { useNotesCardStyles } from './notes-card.styles';
import { useTextStyles } from '../../../theme/text';
import clsx from 'clsx';
import { Note, NoteProps } from '../note/note.component';
import { ErrorMessage, LoadingOverlay, NoResultsMessage } from '../list-table/list-table.component';
import { TextButton } from '../text-button/text-button.component';
import { Refresh } from '@mui/icons-material';

export interface NotesCardComponentProps {
  isLoading?: boolean;
  isBackgroundLoading?: boolean; // Not being used
  hasError: boolean;
  hasNextPage?: boolean;
  removeShadow?: boolean; // Not being used
  notes: NoteProps[];
  /** Absent hides the button, for a panel that only reads. */
  onAddNote?: () => void;
  onClick(): void;
}

export const NotesCard = ({ notes, hasError, hasNextPage, isLoading, onAddNote, onClick }: NotesCardComponentProps) => {
  const classes = useNotesCardStyles({ hasNotes: notes.length > 0 });
  const textClasses = useTextStyles();

  return (
    <>
      <Box className={classes.container}>
        <Card className={classes.card}>
          <Grid
            container
            direction={'row'}
            className={classes.title}
            sx={{
              justifyContent: 'space-between',
              alignItems: 'center'
            }}
          >
            <Grid>
              <Typography className={textClasses.h2}>Notes</Typography>
            </Grid>
            {onAddNote ? (
              <Grid>
                <TextButton color={'secondary'} onClick={onAddNote} variant="outlined">
                  Add note
                </TextButton>
              </Grid>
            ) : null}
          </Grid>
          <Box className={classes.wrapper}>
            <NoResultsMessage open={notes.length < 1 && !isLoading && !hasError} />
            <ErrorMessage open={hasError} />
            <LoadingOverlay isLoading={isLoading} />
            {notes.map((note) => (
              <Note {...note} />
            ))}
            {hasNextPage ? (
              <Typography className={clsx(classes.title, textClasses.h2)}>
                <section className={classes.header}>
                  <TextButton color={'primary'} onClick={onClick} variant="outlined">
                    <Refresh />
                    &nbsp;Load more notes
                  </TextButton>
                </section>
              </Typography>
            ) : null}
          </Box>
        </Card>
      </Box>
    </>
  );
};
